import { cn } from '@/lib/utils'
import { Controller, useFormContext } from 'react-hook-form'
import { SwitchSelect } from '../SwitchSelect'

type OpcaoSwitchSelect<T> = { value: T; label: string }

type FormFieldSwitchSelectProps<T> = {
    name: string
    label: string
    /** Exatamente dois valores mutuamente exclusivos — com três ou mais, use `FormFieldSelect`. */
    options: readonly [OpcaoSwitchSelect<T>, OpcaoSwitchSelect<T>]
    disabled?: boolean
    className?: string
    /** Recebe o `value` da opção escolhida, já no tipo original. */
    onChange?: (value: T) => void
}

/**
 * `SwitchSelect` ligado ao react-hook-form. O valor pode ser de qualquer tipo
 * (boolean, número, enum): o campo mapeia por índice, porque o `SwitchSelect`
 * só compara strings — mesma solução do `FormFieldSelect`.
 */
export function FormFieldSwitchSelect<T>({
    name,
    label,
    options,
    disabled,
    className,
    onChange,
}: FormFieldSwitchSelectProps<T>) {
    const { control } = useFormContext()
    const desabilitado = disabled || (control as any)._options?.disabled
    const opcoesPorIndice = [
        { value: '0', label: options[0].label },
        { value: '1', label: options[1].label },
    ] as const

    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange: onChangeCampo, value } }) => (
                <SwitchSelect
                    label={label}
                    value={value === options[1].value ? '1' : '0'}
                    options={opcoesPorIndice}
                    onChange={indice => {
                        const valor = options[Number(indice)].value
                        onChangeCampo(valor)
                        onChange?.(valor)
                    }}
                    disabled={desabilitado}
                    className={cn('w-full', className)}
                    size="medium"
                    unHelperText={false}
                />
            )}
        />
    )
}
